import React, { createContext, useContext, useMemo, useReducer } from 'react'
import { HeaderProps } from '@microfrontends/app-shell-v2'
import { TAppProps, TAppState, TAppContext } from './types'
import { jobDetailReducer } from './reducer'
import { ELanguage } from '@microfrontends/react-components'
import { EPages, EJobAnalysisType } from '@/common'
import { EJobInvitationStatus, IJobDetail, TJobInvitation, TSpecialJob } from '@/services/jobs/type'
import { TUser } from '@/services'
import { mapTrackingJobProperties } from '@/helpers'
import { TAiCVReview } from '@/services/ai-review'
import { TAITrial } from '@/services/ai-review/types'

export const initialStore: Required<TAppState> = {
    jobDetail: null, // DO NOT USE this jobDetail state
    user: null,
    langCode: ELanguage.VI,
    clientInfo: {
        userIp: [],
        userAgent: '',
        isRobotRequest: false
    },
    pageName: EPages.JOB_DETAIL,
    isShowModalApplyJob: false,
    isShowJobMatchingModal: false,
    isSavedJob: false,
    isAppliedJob: false,
    checkBlacklist: false,
    userType: EJobAnalysisType.NONE,
    // this var using for get job you will love
    ignoreJobIds: [],
    enableTrackingAB: false,
    trackingPageZone: '',
    trackingJobProperties: {},
    jobInvitation: {
        jobInvitationId: 0,
        status: EJobInvitationStatus.WAITING,
        content: ''
    },
    cvReviews: [],
    cvReviewTrial: null,
    topBannerData: null
}

const Context = createContext<TAppContext>({
    state: initialStore,
    props: {
        langCode: ELanguage.VI,
        jobDetail: null
    },
    dispatch: () => { }
})

export type TJobDetailProviderProps = TAppProps & {
    children: React.ReactNode
    user: Partial<TUser> | null
    jobDetail: Partial<IJobDetail>
    userType: EJobAnalysisType
    jobInvitation: TJobInvitation
    specialJob?: TSpecialJob
    cvReviews?: TAiCVReview[]
    cvReviewTrial?: TAITrial | null
    topBannerData?: HeaderProps['topBannerData']
}

export const useAppStore = () => useContext(Context)

const JobDetailProvider = (props: TJobDetailProviderProps) => {

    const [state, dispatch] = useReducer(jobDetailReducer, {
        ...initialStore,
        user: props.user,
        userType: props.userType,
        jobInvitation: props.jobInvitation,
        isSavedJob: props.specialJob?.isSavedJob ?? false,
        isAppliedJob: props.specialJob?.isApplied ?? false,
        checkBlacklist: props.specialJob?.isUserBlacklist ?? false,
        trackingJobProperties: mapTrackingJobProperties(props.jobDetail),
        cvReviews: props.cvReviews ?? [],
        cvReviewTrial: props.cvReviewTrial ?? null,
        topBannerData: props.topBannerData
    })

    const contextValue = useMemo(() => {
        return {
            state,
            props,
            dispatch
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [state])

    return (
        <Context.Provider value={contextValue}>{props.children}</Context.Provider>
    )
}

export default JobDetailProvider
